//imports
import React, { Fragment, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Routes, Route, Navigate } from 'react-router-dom';

//views
import MainView from 'Modules/realtimeMaps/views/main';

//components outside the router scope
import ModalManageLandmark from './main/components/LandmarksListMain/components/ModalManageLandmark'
import MapUtilitiesMenu from './main/components/MapUtilitiesMenu'
import ModalMarkerRoute from '../../modules/routes/views/templates/components/modalMarkerRoute';
import ModalMarkerRouteDirections from '../../modules/routes/views/templates/components/modalDirections';
import ModalTroubleshootDevice from 'Modules/.common/components/TroubleshootDevice';
import ModalWarnings from 'Modules/.common/components/Warnings';
import LandmarkCreateEdit from './main/components/landmarks/components/landmarkCreateEdit'

//router
const routerRealtimeMaps = () => {

	const { messages } = useIntl()
	const mapRef = useRef()

	const openModalMarkerInfo = useSelector(state => state.routesManagerModalMarkerRouteRedux.open);
	const openModalRouteDirections = useSelector(state => state.routesManagedDirectionRedux?.open);
	const isRealtimeMaps = useSelector(state => state.routesManagedDirectionRedux?.isRealtimeMaps);
	const openModalTroubleshootDevice = useSelector(state => state.troubleshootDeviceRedux.open);
	const openModalWarnings = useSelector(state => state.warningsRedux.open);
	const openLandmarkCreateEdit = useSelector((state) => state.realtimeMapLandmarkCreateEditModuleRedux.open);
	const formToOpenCreateLandmark = useSelector((state) => state.realtimeMapLandmarkCreateEditModuleRedux.form);

	return (
		<Fragment>
			<Routes>
				<Route path='/' element={<Navigate to="/app/realtimemaps/main" />}></Route>
				<Route path='main' element={<MainView mapRef={mapRef} />} />
				<Route path="*" element={<Navigate to="/app/error" />} />
			</Routes>
			<MapUtilitiesMenu mapRef={mapRef} />
			<ModalManageLandmark messages={messages} />
			{ openModalMarkerInfo && <ModalMarkerRoute mapRef={mapRef} /> }
			{ openModalRouteDirections && isRealtimeMaps && <ModalMarkerRouteDirections mapRef={mapRef} isRealtimeMaps/>}
			{ openModalTroubleshootDevice && <ModalTroubleshootDevice />}
			{ openModalWarnings && <ModalWarnings /> }
			{ openLandmarkCreateEdit && (formToOpenCreateLandmark == 'vehicleTrails' || formToOpenCreateLandmark == 'infoBubble') && <LandmarkCreateEdit mapRef={mapRef}/> }
		</Fragment>
	);
};

export default routerRealtimeMaps;
